import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 7.5L12 4L20 7.5L12 11L4 7.5Z" fill="currentColor" />
    <path d="M4 11.5L12 15L20 11.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 15.5L12 19L20 15.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <footer className="bg-white pt-24 pb-12">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-8 text-black">
              <Logo size={28} />
              <span className="font-display text-xl tracking-tighter">SORA</span>
            </div>
            <p className="text-lg text-gray-500 max-w-sm font-medium leading-relaxed">
              Sôra — feito com professores, para professores. Nosso compromisso é transformar o planejamento em um momento de inspiração, não de sobrecarga.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-black uppercase tracking-widest text-black mb-8 opacity-50">Navegação</h4>
            <ul className="space-y-4">
              <li><a href="#sobre" className="text-gray-500 hover:text-purple-600 font-bold transition-colors">Sobre</a></li>
              {/* <li><a href="#blog" className="text-gray-500 hover:text-purple-600 font-bold transition-colors">Blog</a></li> */}
              <li><a href="#planos" className="text-gray-500 hover:text-purple-600 font-bold transition-colors">Planos</a></li>
              <li><button onClick={handleLoginClick} className="text-gray-500 hover:text-purple-600 font-bold transition-colors">Entrar</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-black uppercase tracking-widest text-black mb-8 opacity-50">Legal</h4>
            <ul className="space-y-4">
              <li><a href="#" className="text-gray-500 hover:text-purple-600 font-bold transition-colors">Contato</a></li>
              <li><a href="#" className="text-gray-500 hover:text-purple-600 font-bold transition-colors">Privacidade</a></li>
              <li><a href="#" className="text-gray-500 hover:text-purple-600 font-bold transition-colors">Termos</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-gray-400 font-medium text-sm">
            © {currentYear} Sora. Todos os direitos reservados.
          </p>
          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center hover:bg-purple-100 hover:text-purple-600 transition-all">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

